import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import FAQ from "@/components/FAQ";
import LeadMagnet from "@/components/LeadMagnet";
import NextPageCta from "@/components/NextPageCta";
import { BOOK_URL } from "@/lib/booking";

export default function FAQPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="FAQ"
        title="Straight"
        italic="answers."
        blurb="Pricing, insurance, deposit guarantees, lead times and what's included — the questions I get asked the most."
      />
      <FAQ />
      <LeadMagnet />
      <NextPageCta href={BOOK_URL} label="Ready to book? →" sub="Live availability on my diary — pick a slot in seconds." />
    </Layout>
  );
}
